import { render, staticRenderFns } from "./COAImports.vue?vue&type=template&id=6f795ec2"
import script from "./COAImports.vue?vue&type=script&lang=js"
export * from "./COAImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports